import React from 'react';
import { services } from '../mockData';
import { Link } from 'react-router-dom';
import { Clock, Calendar, Scissors, Sparkles, Target } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Services = () => {
  const { currentUser } = useAuth();

  const included = [
    { icon: <Scissors size={32} style={{ color: 'var(--ss-green)' }} />, title: 'Consultation', desc: 'Personalized style discussion with your barber' },
    { icon: <Sparkles size={32} style={{ color: 'var(--ss-green)' }} />, title: 'Premium Products', desc: 'High-quality grooming products used' },
    { icon: <Target size={32} style={{ color: 'var(--ss-green)' }} />, title: 'Precision Styling', desc: 'Expert finishing and styling techniques' },
  ];

  return (
    <div className="sauce-sity-page" data-testid="services-page">
      <div className="sauce-sity-content">
        <div className="ss-section-header ss-mb-48">
          <h1 className="ss-title-xl">
            Our <span className="ss-highlight-purple">Services</span>
          </h1>
          <p className="ss-section-subtitle">
            Premium grooming services tailored to your style. Every service includes consultation and styling.
          </p>
        </div>

        <div className="ss-grid-3 ss-mb-48">
          {services.map((service) => (
            <div key={service.id} className="ss-feature-card" data-testid={`service-card-${service.id}`}>
              <div className="ss-feature-icon">
                <Scissors size={40} style={{ color: 'var(--ss-green)', margin: '0 auto' }} />
              </div>
              <h3 className="ss-feature-title">{service.name}</h3>
              <p className="ss-feature-desc ss-mb-16">{service.description}</p>

              <div style={{ color: 'var(--ss-white-soft)', marginBottom: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
                <Clock size={16} style={{ color: 'var(--ss-green)' }} />
                <span>{service.duration} minutes</span>
              </div>

              {currentUser ? (
                <Link to="/booking" state={{ selectedService: service }}>
                  <button className="ss-btn ss-btn-primary ss-btn-full" data-testid={`book-service-${service.id}`}>
                    <Calendar size={18} />
                    Book This Service
                  </button>
                </Link>
              ) : (
                <Link to="/login">
                  <button className="ss-btn ss-btn-primary ss-btn-full" data-testid={`signin-service-${service.id}`}>
                    Sign In to Book
                  </button>
                </Link>
              )}
            </div>
          ))}
        </div>

        <div className="ss-card ss-card-purple" data-testid="whats-included-section">
          <h2 className="ss-title-lg ss-text-center ss-mb-24">What's <span className="ss-highlight-green">Included</span></h2>
          <div className="ss-grid-3">
            {included.map((item, i) => (
              <div key={i} className="ss-text-center">
                <div style={{
                  background: 'rgba(170,255,0,0.12)',
                  width: 72, height: 72,
                  borderRadius: '999px',
                  display: 'inline-flex',
                  alignItems: 'center', justifyContent: 'center',
                  marginBottom: 14,
                }}>{item.icon}</div>
                <h3 className="ss-title-md">{item.title}</h3>
                <p className="ss-text">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
